// React things
import { useEffect, useState, lazy, Suspense } from "react";
import { useNavigate } from "react-router-dom";
// Styles
import style from "./Application.module.css";

const mainRiveComponent = `/optimization.riv`;
const bckg_lines = `/bckg.webp`;
const task_background = `/task-background.webp`;
const game = `/game.webp`;
const achivement = `/achivement.webp`;
const headerNight = `/header-night.webp`;
const green_section = `/green-section.webp`;
const purple_section = `/purple-section.webp`;
const message_ok = `/message-ok.webp`;
const message_error = `/message-error.webp`;
import helloSticker from "./Project/Components/Onboarding/images/Hello_11zon.webp";
import dcSticker from "./Project/Components/Onboarding/images/Coin_11zon.webp";
import miningSticker from "./Project/Components/Onboarding/images/Mine_11zon.webp";
import charactersSticker from "./Project/Components/Onboarding/images/Rare_11zon.webp";
import fortuneSticker from "./Project/Components/Onboarding/images/Wheel_11zon.webp";
import message_win from "/message-win.png";
// Router
import Router from "./Project/Router/Router.jsx";

// Stores
import useSourceStore from "./Project/Store/SourceStore.js";
import {
  addInDownloadsStorage,
  downloadWrapper,
} from "./Project/Store/DownloadManager.js";
import useApplicationSettings from "./Project/Store/ApplicationSettings.js";
import useUserStore from "./Project/Store/UserStore.js";

// Service
import {
  getDailyRewards,
  loginUser,
  getUserBalance,
} from "./Project/Services/Requests.ts";

// Components
import Menubar from "./Project/Components/Menubar/Menubar.jsx";
import DialogMenuProvider from "./Project/Components/DialogMenu/DialogMenuProvider.jsx";
// import LoadingWrapper from "./Project/ComponentsWrappers/LoadingWrapper.jsx"
import Loading from "./Project/Components/Loading/Loading.jsx";
const NotMobile = lazy(() => import("./Project/Pages/NotMobile.jsx"));
import Onboarding from "./Project/Components/Onboarding/Onboarding";
import MaintenancePage from "./Project/Components/MaintenancePage/MaintenancePage.jsx";
import NotificationWrapper from "./Project/Components/Notifications/NotificationWrapper.tsx";
import { useModalStore } from "./Project/Store/ModalStore.ts";
import BlockedPage from "./Project/Components/BlockedPage/BlockedPage.tsx";
import { TelegramWebAppProvider } from "./Project/Telegram/WebAppProvider";
import { FetchSponsorsTasks } from "./utils/SponsorTasksFetch";

async function loadImage(src) {
  const response = await fetch(src);
  const blob = await response.blob();
  return URL.createObjectURL(blob);
}

function Application() {
  const navigate = useNavigate();
  const background = useSourceStore((state) => state.background);

  const [isMobie, setIsMobile] = useState(false);

  const [isFullSize, setIsFullSize] = useState(false);

  const tg = window.Telegram.WebApp;

  // ApplicationSettings
  const showMenubar = useApplicationSettings((state) => state.showMenubar);
  const contentToLoad = useApplicationSettings((state) => state.contentToLoad);
  const loadedContent = useApplicationSettings((state) => state.loadedContent);

  const setLocalization = useApplicationSettings(
    (state) => state.setLocalization
  );
  const localization = useApplicationSettings((state) => state.localization);

  // SourceStore Setters
  const setBackground = useSourceStore((state) => state.setBackground);
  const setRiveComponent = useSourceStore((state) => state.setRiveComponent);
  const setTaskBackground = useSourceStore((state) => state.setTaskBackground);
  const allLoaded = useSourceStore((state) => state.allLoaded);
  const setGame = useSourceStore((state) => state.setGame);
  const setAchivement = useSourceStore((state) => state.setAchivement);
  const setHeaderNight = useSourceStore((state) => state.setHeaderNight);
  const setPurpleSection = useSourceStore((state) => state.setPurpleSection);
  const setGreenSection = useSourceStore((state) => state.setGreenSection);
  const setMessageOk = useSourceStore((state) => state.setMessageOk);
  const setMessageError = useSourceStore((state) => state.setMessageError);
  const setMessageWin = useSourceStore((state) => state.setMessageWin);

  // UserStore

  const [isOnboardingComplete, setIsOnboardingComplete] = useState(false);
  const [isLoadingOnboardingStatus, setIsLoadingOnboardingStatus] =
    useState(true);

  const [hasError, setHasError] = useState(false);
  const [isBlocked, setIsBlocked] = useState(false);
  const excludedUserIds = [
    337937791, 1009441970, 353357144, 6944819896, 7450596180, 508501888,
    336417426, 479588079, 567897340, 606261842
  ];

  const [dailyRewardData, setDailyRewardData] = useState(null);
  const [isClaimed, setIsClaimed] = useState();
  const setOpen = useModalStore((state) => state.setOpen);
  const setBalanceDC = useUserStore((state) => state.setBalanceDC);
  const setBalanceUSDT = useUserStore((state) => state.setBalanceUSDT);

  const userAgent = navigator.userAgent;

  useEffect(() => {
    const fetchDailyTasks = async () => {
      try {
        const response = await getDailyRewards();
        if (response) {
          setDailyRewardData(response);
        }
      } catch (error) {
        console.error("Ошибка при получении ежедневных наград:", error);
      }
    };

    fetchDailyTasks();
  }, []);

  useEffect(() => {
    if (dailyRewardData !== null || isOnboardingComplete) {
      const thisDayPrize = dailyRewardData?.tasks?.filter(
        (item) => item.details.current_day
      );

      if (thisDayPrize[0]?.status === "NOT_STARTED") {
        setIsClaimed(true);
      }

      if (isClaimed) {
        if (location.pathname === "/") {
          setTimeout(() => {
            setOpen(true);
          }, 1000);
        }
      }
    }
  }, [dailyRewardData, setOpen, isClaimed]);

  useEffect(() => {
    console.log("Инициализация приложения...");

    // Настройка Telegram WebApp
    tg.setHeaderColor("#1F0234");
    tg.setBackgroundColor("#000");
    tg.expand();
    tg.BackButton.hide();

    // Обработка start_param для перенаправления
    const startParam = tg.initDataUnsafe.start_param;
    if (startParam) {
      // Проверяем формат start_param
      if (startParam.startsWith("giveaway_")) {
        // Извлекаем ID из параметра (например, giveaway_123)
        const giveawayId = startParam.split("_")[1];
        navigate(`/giveaway/${giveawayId}`);
      } else if (startParam === "giveaway") {
        navigate("/giveaway");
      }
    }

    const mobileUserIds = new Set([
      5455842028, 353357144, 576590544, 532604352, 337937791, 1009441970,
      1831071065, 7251175646, 381628186, 6944819896, 508501888, 336417426,
      479588079, 567897340, 606261842
    ]);

    if (
      tg.platform === "ios" ||
      tg.platform === "android" ||
      mobileUserIds.has(tg.initDataUnsafe.user.id)
    ) {
      setIsMobile(true);
    }

    // Обработчик изменения размера viewport
    tg.onEvent("viewportChanged", () => {
      if (tg.isExpanded) {
        setIsFullSize(true);
      } else {
        setIsFullSize(false);
      }
    });

    // Инициализация пользователя
    const initializeUser = async () => {
      try {
        console.log("Начало инициализации пользователя...");
        const userData = await loginUser(userAgent);

        // Получаем баланс пользователя
        await getUserBalance();

        console.log("Успешная инициализация пользователя:", userData);

        // Используем статус онбординга из ответа логина
        if (userData.passed === "false") {
          setIsOnboardingComplete(false);
        } else {
          setIsOnboardingComplete(true);
        }

        setIsLoadingOnboardingStatus(false);

        //модалку вызывать
      } catch (error) {
        if (error.response.status === 401) {
          console.error("Пользователь заблокирован:", error);
          setIsBlocked(true);
          setIsOnboardingComplete(false);
          setIsLoadingOnboardingStatus(false);
        } else {
          console.error("Ошибка при инициализации пользователя:", error);
          setHasError(true);
          setIsOnboardingComplete(false);
          setIsLoadingOnboardingStatus(false);
        }
      }
    };

    // Базовая инициализация
    setLocalization("rus");
    downlaodFiles();
    openedTasksChecker();

    // Запуск инициализации пользователя
    initializeUser();

    return () => {
      // axios.interceptors.response.eject(interceptor);
    };
  }, []);

  function openedTasksChecker() {
    if (!localStorage.getItem("tasksGroups")) {
      localStorage.setItem(
        "tasksGroups",
        JSON.stringify({
          1: true,
          2: false,
          3: false,
        })
      );
    }
  }

  function downlaodFiles() {
    addInDownloadsStorage(
      downloadWrapper(mainRiveComponent, setRiveComponent),
      "main_rive_object"
    );

    addInDownloadsStorage(
      downloadWrapper(bckg_lines, setBackground),
      "background_img"
    );

    addInDownloadsStorage(
      downloadWrapper(task_background, setTaskBackground),
      "task_background"
    );

    addInDownloadsStorage(downloadWrapper(game, setGame), "game_profile_img");

    addInDownloadsStorage(
      downloadWrapper(achivement, setAchivement),
      "achivement_profile_img"
    );

    addInDownloadsStorage(
      downloadWrapper(headerNight, setHeaderNight),
      "header_night_profile_img"
    );

    addInDownloadsStorage(
      downloadWrapper(message_win, setMessageWin),
      "message-win"
    );

    addInDownloadsStorage(
      downloadWrapper(green_section, setGreenSection),
      "lottery-wheel-green-section"
    );
    //purple_section
    addInDownloadsStorage(
      downloadWrapper(purple_section, setPurpleSection),
      "lottery-purple-green-section"
    );

    addInDownloadsStorage(
      downloadWrapper(message_ok, setMessageOk),
      "message-ok"
    );

    addInDownloadsStorage(
      downloadWrapper(message_error, setMessageError),
      "message-error"
    );

    Promise.all([
      loadImage(helloSticker),
      loadImage(dcSticker),
      loadImage(miningSticker),
      loadImage(charactersSticker),
      loadImage(fortuneSticker),
    ]).then(([hello, dc, mining, characters, fortune]) => {
      useSourceStore.getState().setOnboardingImage("hello", hello);
      useSourceStore.getState().setOnboardingImage("dc", dc);
      useSourceStore.getState().setOnboardingImage("mining", mining);
      useSourceStore.getState().setOnboardingImage("characters", characters);
      useSourceStore.getState().setOnboardingImage("fortune", fortune);
    });
  }

  const handleOnboardingComplete = () => {
    // Просто переключаем на главную страницу
    setIsOnboardingComplete(true);
  };

  const isUpdate = false;
  if (isUpdate && !excludedUserIds.includes(tg.initDataUnsafe.user.id)) {
    return (
      <>
        <MaintenancePage />
        <div className={style["background"]}>
          <img src={background} />
        </div>
      </>
    );
  }

  if (hasError && !excludedUserIds.includes(tg.initDataUnsafe.user.id)) {
    return (
      <>
        <MaintenancePage />
        <div className={style["background"]}>
          <img src={background} />
        </div>
      </>
    );
  }

  if (isBlocked) {
    return (
      <>
        <BlockedPage />
      </>
    );
  }

  if (!isMobie) {
    return (
      <Suspense fallback={<div>Загрузка...</div>}>
        <NotMobile />
      </Suspense>
    );
  }

  if (!isFullSize) {
    <div> Разверни!</div>;
  }

  if (!allLoaded) {
    return (
      <div className={style["loading-wrapper"]}>
        <div className={style["loading-container"]}>
          <Loading />
        </div>

        <div>{localization["application_loadingMessage"]}</div>
        <div>
          {localization["applicatoin_alreadyLoaded"]} {loadedContent} /{" "}
          {contentToLoad}
        </div>
      </div>
    );
  }

  if (isLoadingOnboardingStatus) {
    return (
      <div className={style["loading-wrapper"]}>
        <div className={style["loading-container"]}>
          <Loading />
        </div>
        <div>Проверка статуса...</div>
      </div>
    );
  }

  if (!isOnboardingComplete) {
    return (
      <>
        <Onboarding onComplete={handleOnboardingComplete} />
        <div className={style["background"]}>
          <img src={background} />
        </div>
      </>
    );
  }

  return (
    <TelegramWebAppProvider>
      <div className={style["container"]}>
        <div className={style["content-wrapper"]}>
          {/* <MessageDialogProvider /> */}
          <NotificationWrapper />
          <div className={style["content"]}>
            <Router />
          </div>
          <div
            className={`${style["menubar"]} ${!showMenubar && style["menubar-hide"]
              }`}
          >
            <div className={style["main-button-glow"]}></div>
            <div className={style["menubar-wrapper"]}>
              <Menubar />
            </div>
          </div>
        </div>

        <DialogMenuProvider />

        <div className={style["background"]}>
          <img src={background} />
        </div>
      </div>

      {/* Компонент для загрузки спонсорских заданий */}
      <FetchSponsorsTasks />
    </TelegramWebAppProvider>
  );
}

export default Application;
